import { generatePasscode } from '@/lib/crypto/passcode'
import type { PasscodeOptions } from '@/types/share'

/**
 * Initialize passcode options on first mount.
 * Returns updated options if a passcode needs to be generated, or null if no change needed.
 */
export function initializePasscodeOptions(options: PasscodeOptions): PasscodeOptions | null {
  if (!options.passcode && !options.useCustomPasscode && !options.isPublic) {
    return { ...options, passcode: generatePasscode() }
  }
  return null
}

/**
 * Enforce tier rules on passcode options.
 * Custom passcodes require Pro tier — downgrades to auto-generated if not Pro.
 * Returns updated options if a change is needed, or null if no change needed.
 */
export function enforcePasscodeTierRules(options: PasscodeOptions, tier: string): PasscodeOptions | null {
  const isPro = tier === 'pro'
  if (!isPro && options.useCustomPasscode) {
    return { ...options, useCustomPasscode: false, passcode: generatePasscode() }
  }
  return null
}
